import { render, staticRenderFns } from "./ThirtyTable.vue?vue&type=template&id=28289e36&"
import script from "./ThirtyTable.vue?vue&type=script&lang=js&"
export * from "./ThirtyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports